/**
 * Coerces a yes/no style answer into a boolean for the LDS lead payload.
 *
 * Accepts native booleans as well as the case-insensitive strings
 * "true"/"false"/"yes"/"no". Any null, undefined, or unrecognized value
 * resolves to `undefined` so the field is omitted rather than sent as a
 * misleading truthy string.
 */
const coerceYesNoBoolean = (value: unknown): boolean | undefined => {
  if (value === undefined || value === null) {
    return undefined;
  }

  const normalized = String(value).toLowerCase();

  if (value === false || normalized === 'false' || normalized === 'no') {
    return false;
  }

  if (value === true || normalized === 'true' || normalized === 'yes') {
    return true;
  }

  return undefined;
};

export default coerceYesNoBoolean;
